export const deleteSpaces = (str: string) => str.replace(/\s+/g, "");
